import { contrastRatio } from '@yola/yola-palette-generator';
import isDark from '../verifiers/is-dark';
import reduceColorPointByStep from '../utils/reduce-color-point-by-step';
import increaseColorPointByStep from '../utils/increase-color-point-by-step';

const secondaryButtonColorBorderTextRule = (params) => {
  const { primaryColor, backgroundColor, primaryColorPalette, whiteColor, blackColor } = params;

  const fallback = {
    rule: 'secondaryButton.colorBorder.text.default',
    params,
  };
  if (!isDark(backgroundColor) || contrastRatio(backgroundColor, primaryColor) >= 4.5) {
    return primaryColor;
  }

  if (contrastRatio(primaryColor, whiteColor) > contrastRatio(backgroundColor, whiteColor)) {
    if (primaryColor.equals(primaryColorPalette[900])) {
      return blackColor;
    }

    return increaseColorPointByStep({
      targetColor: primaryColor,
      targetColorPalette: primaryColorPalette,
      step: 1,
      fallback,
    });
  }
  if (primaryColor.equals(primaryColorPalette[50])) {
    return whiteColor;
  }

  return reduceColorPointByStep({
    targetColor: primaryColor,
    targetColorPalette: primaryColorPalette,
    step: 1,
    fallback,
  });
};

export default secondaryButtonColorBorderTextRule;
